import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { configApi } from 'Api';

import type { CourseFormOptions } from '../types';

interface UseCourseFormOptionsResult {
  formOptions: CourseFormOptions | null;
  isLoadingOptions: boolean;
  optionsError: string | null;
  isBasicDataLoaded: boolean;
}

export const useCourseFormOptions = (): UseCourseFormOptionsResult => {
  const { t } = useTranslation();
  const [formOptions, setFormOptions] = useState<CourseFormOptions | null>(null);
  const [isLoadingOptions, setIsLoadingOptions] = useState(true);
  const [optionsError, setOptionsError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCourseFormOptions = async () => {
      setIsLoadingOptions(true);
      setOptionsError(null);

      try {
        const result = await configApi.getCourseFormOptions();

        if (result.isSuccess && result.data) {
          setFormOptions(result.data);
        } else {
          setOptionsError(result.error ?? t('courseForm.errorLoadingOptions'));
        }
      } catch {
        setOptionsError(t('courseForm.errorLoadingOptions'));
      } finally {
        setIsLoadingOptions(false);
      }
    };

    fetchCourseFormOptions();
  }, [t]);

  const isBasicDataLoaded = !isLoadingOptions && !!formOptions;

  return {
    formOptions,
    isLoadingOptions,
    optionsError,
    isBasicDataLoaded
  };
};
